// extracted by mini-css-extract-plugin
module.exports = {"wf46mqp":"wf46mqp"};